var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-animation"},[_c('div',{staticClass:"spinner-wrapper"},[_c('spinner',{attrs:{"size":"massive"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }